<template>
    <div>
        <b-container fluid class="mt--7">
            <b-row>
                <b-col>
                    <audit-log-table title="Logs" />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import AuditLogTable from './AuditLogTable'
import permissionsMixins from '@/mixins/permissionsMixins'


export default {
    name: 'auditLogs',
    components: {
        AuditLogTable,
    },mixins: [permissionsMixins],

    data: () => {
        return {}
    },

    methods: {},
}
</script>
<style></style>
